import { FSMoneyFactory } from "../money/moneyFactory";

/**
 * Calculate the price using the library for decimal Math Big.JS
 *
 */
export class OrderCreationPriceCalculator {
  /**
   * Get the netto price of a single OrderUnit
   * @param {*} orderUnitData
   */
  static getOrderUnitPrice(ou) {
    let orderUnitPrice = FSMoneyFactory.toMoney(0);

    ou?.orderUnitsProducts?.forEach(p => {
      const productInfo = ou.products.find(
        x => x.id === p.productId.toString(),
      );

      const netProductPrice = FSMoneyFactory.toMoney(
        productInfo?.purchasingPriceCents ?? 0,
      ).times(p.productCount);

      orderUnitPrice = orderUnitPrice.plus(netProductPrice);
    });

    return orderUnitPrice;
  }

  /**
   * Get the price of a single OrderUnit with VAT (and deposit)
   * @param {*} orderUnitData
   */
  static getOrderUnitPriceWithVAT(ou) {
    let orderUnitPrice = FSMoneyFactory.toMoney(0);

    // Add the price of each product * count incl VAT
    ou?.orderUnitsProducts?.forEach(p => {
      const productInfo = ou.products.find(
        x => x.id === p.productId.toString(),
      );

      const netProductPrice = FSMoneyFactory.toMoney(
        productInfo?.purchasingPriceCents ?? 0,
      ).times(p.productCount);

      const totalProductPrice = netProductPrice.plus(
        netProductPrice.times(productInfo?.vat ?? 0).div(100),
      );

      orderUnitPrice = orderUnitPrice.plus(totalProductPrice);
    });

    // Add the deposit and its own VAT
    if (ou?.shippingUnitDepositValueCents > 0) {
      const depositValue = FSMoneyFactory.toMoney(
        ou.shippingUnitDepositValueCents,
      );
      const depositVatPercent = FSMoneyFactory.toMoney(ou.vat);
      orderUnitPrice = orderUnitPrice
        .plus(depositValue)
        .plus(depositValue.times(depositVatPercent).div(100));
    }

    return orderUnitPrice;
  }

  /**
   * Calculate the total price in EUR for an order consisting of multiple order units
   *
   * - Includes VAT
   * - Includes Deposit value of free items
   *
   * @param {*} orderUnitInfo - an array of order units + count (a whole order)
   * @returns string - The total price for the order in cents
   */
  static getOrderPriceWithVAT(orderUnitInfo, discountsInKind = []) {
    let price = FSMoneyFactory.toMoney(0);

    orderUnitInfo?.forEach(ou => {
      price = price.plus(
        this.getOrderUnitPriceWithVAT(ou?.orderUnit).times(
          ou?.orderUnitCount ?? 0,
        ),
      );
    });

    discountsInKind.forEach(discount => {
      const depositPrice = FSMoneyFactory.toMoney(
        discount.orderUnit?.shippingUnitDepositValueCents ?? 0,
      ).times(FSMoneyFactory.toMoney(discount.count));

      const depositVatPercent = FSMoneyFactory.toMoney(discount.orderUnit?.vat);

      price = price
        .plus(depositPrice)
        .plus(depositPrice.times(depositVatPercent).div(100));
    });

    return price;
  }

  /**
   * Calculate the netto price in EUR for an order consisting of multiple order units
   *
   * - NO VAT
   * - NO Deposit value of free products
   *
   * @param {*} orderUnitInfo - an array of order units + count (a whole order)
   * @returns string - The netto price for the order in cents
   */
  static getOrderPrice(orderUnitInfo) {
    let price = FSMoneyFactory.toMoney(0);

    orderUnitInfo?.forEach(ou => {
      price = price.plus(
        this.getOrderUnitPrice(ou?.orderUnit).times(ou?.orderUnitCount ?? 0),
      );
    });

    return price;
  }
}
